<template>
    <div v-if="isDisplay"
        :class="['preview-custom-img', formCustomImage.positionIndex != maxComponent - 1 ? 'm-b-16' : '']">
        <div class="swift-custom-img">
            <img :class="[formCustomImage.size, formCustomImage.animation+'-'+time, formCustomImage.isRepeat ? 'infinite' : '']"
                :src="imgSrc || require('./../../assets/no-img.svg')" 
                alt="custom-img">
        </div>
    </div>
</template>
<script>
import { listComponentDefault } from './../../constant'
export default {
    name: "PreviewCustomImage",
    props: {
        value: {
            type: Object,
            required: true,
        },
        isDisplay: {
            type: Boolean,
            required: true
        },
        time: {
            type: Number,
            required: true
        }
    },
    computed: {
        formCustomImage: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", this.value);
            },
        },
        imgSrc() {
            let src = ""
            if ( this.defaultImgs.includes(this.formCustomImage.imgUrl) ) {
                src = this.getImgUrl(this.formCustomImage.imgUrl)
            } else {
                src = typeof(this.formCustomImage.imgUrl) === 'object' ? this.formCustomImage.imgUrl.src : this.formCustomImage.imgUrl
            }
            return src
        },
        maxComponent() {
            return listComponentDefault.length
        }
    },

    data() {
        return {
           defaultImgs: ['logo.svg', 'logo-sm.svg']
        };
    },

    created() {},
};
</script>

<style lang="scss">
</style>
